<template>
    <div>
        <template v-if="hasPermission===1">
            <div class="forms">
                <div class="text">基础信息</div>
                <el-form  :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
                    <el-form-item label="主账号使用状态" prop="usingStatus">
                        <template #label>
                            <div class="custom-label">主账号<br />使用状态</div>
                        </template>
                        <el-select v-model="form.usingStatus" placeholder="请选择"  :disabled="!permission.edit">
                            <el-option v-for="item in dictionaries.property_paccount_ustatus" :key="item.dictId"
                                :label="item.dictName" :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属平台" prop="platformKey">
                        <template #label>
                            <div class="custom-label">所属平台</div>
                        </template>
                        <el-select v-model="form.platformKey" placeholder="请选择" :disabled="!permission.edit" filterable>
                            <el-option v-for="(item, index) in shops" :key="index" :label="item"
                                :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否有子账号" prop="hasSubsidiary">
                        <template #label>
                            <div class="custom-label">是否<br />有子账号</div>
                        </template>
                        <el-radio-group v-model="form.hasSubsidiary" class="el-input" @change="toggleHasSubAccount" :disabled="!permission.edit">
                            <el-radio v-for="item in hasSubsidiaryList" :key="item.dictId" :label="item.dictId">{{
                                item.dictName
                            }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="登录网址" prop="loginUrl">
                        <div class="textarea-con">
                            <el-input v-model="form.loginUrl" placeholder="请输入" clearable maxlength="128" type="textarea" rows="3" show-word-limit  :disabled="!permission.edit"></el-input>
                            <template  v-if="permission.copy">
                                <div v-if="form.loginUrl" class="btn-copy" @click="onCopy(form.loginUrl)">复</div>
                                <div v-else class="btn-copy btn-copy-dis">复</div>
                            </template>
                        </div>
                    </el-form-item>
                    <el-form-item label="注册形式" prop="regType" >
                        <template #label>
                            <div class="custom-label">注册形式</div>
                        </template>
                        <el-radio-group v-model="form.regType" class="el-input" :disabled="!permission.edit">
                            <el-radio v-for="item in dictionaries.property_paccount_reg_type" :key="item.dictId"
                                :label="item.dictId">{{
                                    item.dictName }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="form.regType==1">
                        <el-form-item label="公司主体" prop="companyName" >
                            <el-input v-model="form.companyName" placeholder="请输入" clearable maxlength="50" type="textarea" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="法人/经营人" class="label-star" prop="legalPerson">
                            <template #label>
                                <div class="custom-label">法人/经<br />营人</div>
                            </template>
                            <el-input v-model="form.legalPerson" placeholder="请输入" clearable maxlength="30" type="textarea" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item label="账号名称">
                        <el-input v-model="form.accountName" placeholder="请输入" clearable maxlength="64" type="text" show-word-limit :disabled="!permission.edit"></el-input>
                    </el-form-item>
                    <!-- 显示类型 1 全部 2 子账号使用人, 只返回除了主账号以外的其他信息 -->
                    <!-- 主账号开始 -->
                    <template v-if="form.showType==1">
                        <div class="line"></div>
                        <div class="text">主账号</div>
                        <el-form-item label="登录账号" prop="mainAccount.account">
                            <div class="textarea-con">
                                <el-input v-model="form.mainAccount.account" placeholder="请输入" clearable maxlength="48" type="textarea" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                <template  v-if="permission.copy">
                                    <div v-if="form.mainAccount.account" class="btn-copy" @click="onCopy(form.mainAccount.account)">复</div>
                                    <div v-else class="btn-copy btn-copy-dis">复</div>
                                </template>
                            </div>
                        </el-form-item>
                        <el-form-item label="账号密码" prop="mainAccount.password">
                            <div class="textarea-con">
                                <!-- 编辑 -->
                                <template  v-if="isDetail">
                                    <el-input v-if="form.mainAccount.passwordEye" v-model="form.mainAccount.password" placeholder="请输入" clearable maxlength="48" type="textarea"  rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                    <el-input v-else value="******" clearable maxlength="48" type="textarea"  rows="3" readonly></el-input>
                                </template>
                                <!-- 新建 -->
                                <el-input v-else v-model="form.mainAccount.password" placeholder="请输入" clearable maxlength="48" type="textarea"  rows="3" show-word-limit></el-input>
                                <!-- 复制查看按钮 -->
                                <template  v-if="permission.copy">
                                    <div v-if="form.mainAccount.password" class="btn-copy" @click="onCopy(form.mainAccount.password)">复</div>
                                    <div v-else class="btn-copy btn-copy-dis">复</div>
                                </template>
                                <template  v-if="permission.password">
                                    <div v-if="form.mainAccount.passwordEye" class="i-eye" @click="onEye('main')" ></div>
                                    <div v-else class="i-eye-hide" @click="onEye('main')"></div>
                                </template>
                            </div>
                        </el-form-item>
                        <el-form-item label="账号使用人" prop="mainAccount.usingUserList">
                            <el-select v-model="form.mainAccount.usingUserList" @click.native="openUserPicker(permission.edit,'main')" key="main" value-key="name"
                                        class="select-u" :class="!permission.edit ? 'disabled' : ''" placeholder="选择账号使用人" collapse-tags
                                        size="medium" multiple popper-class="hidden" :disabled="!permission.edit">
                                <el-option v-for="(wc, index) in form.mainAccount.usingUserList" :label="wc.name" :key="index" :value="wc"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="clear-both"></div>
                        <el-form-item label="账号绑定手机号" prop="mainAccount.phone" class="label-star">
                            <template #label>
                                <div class="custom-label">账号绑定<br />手机号</div>
                            </template>
                            <el-input v-model="form.mainAccount.phone" placeholder="请输入" clearable maxlength="11"
                                @input="getOwnerName('main', 'phone')" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定手机号所属员工">
                            <template #label>
                                <div class="custom-label">绑定手机号<br />所属员工</div>
                            </template>
                            <el-input v-model="form.mainAccount.phoneOwner" placeholder="自动识别" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="绑定微信号" prop="mainAccount.wechat">
                            <template #label>
                                <div class="custom-label">绑定微信号</div>
                            </template>
                            <el-input v-model.lazy="form.mainAccount.wechat" placeholder="请输入" clearable maxlength="20"
                                    @input="getOwnerName('main', 'wechat')"  show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定微信号所属员工">
                            <template #label>
                                <div class="custom-label">绑定微信号<br />所属员工</div>
                            </template>
                            <el-input v-model="form.mainAccount.wechatOwner" placeholder="自动识别" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="绑定QQ号" prop="mainAccount.qq">
                            <template #label>
                                <div class="custom-label">绑定QQ号</div>
                            </template>
                            <el-input v-model="form.mainAccount.qq" placeholder="请输入" clearable maxlength="12"
                                @input="getOwnerName('main', 'qq')" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定QQ号所属员工">
                            <template #label>
                                <div class="custom-label">绑定QQ号<br />所属员工</div>
                            </template>
                            <el-input v-model="form.mainAccount.qqOwner" placeholder="自动识别" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="绑定邮箱" prop="mainAccount.email">
                            <template #label>
                                <div class="custom-label">绑定邮箱</div>
                            </template>
                            <el-input v-model="form.mainAccount.email" placeholder="请输入" clearable maxlength="256"
                                @input="getOwnerName('main', 'email')" :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定邮箱所属员工">
                            <template #label>
                                <div class="custom-label">绑定邮箱<br />所属员工</div>
                            </template>
                            <el-input v-model="form.mainAccount.emailOwner" placeholder="自动识别" disabled></el-input>
                        </el-form-item>
                        <div>
                            <el-form-item label="是否有ID" prop="mainAccount.hasId">
                                <template #label>
                                    <div class="custom-label">是否有ID</div>
                                </template>
                                <el-radio-group v-model="form.mainAccount.hasId" class="radio-group" @change="toggleMainHasId">
                                    <el-radio v-for="item in hasIdList" :key="item.dictId" :label="item.dictId" :disabled="!permission.edit">{{
                                        item.dictName }}</el-radio>
                                </el-radio-group>
                                <el-button v-if="form.mainAccount.hasId == 1 && permission.edit" type="primary" plain @click="addPlus(1)" class="add-button add-id">
                                    <i class="el-icon-plus"></i>
                                    新增ID
                                </el-button>
                            </el-form-item>
                        </div>
                        <template v-if="form.mainAccount.hasId === 1">
                            <div v-for="(item, index) in form.mainAccount.accountIdList" :key="'main-id-' + index">
                                <el-form-item label="账号ID(0*)">
                                    <template #label>
                                        <div class="custom-label">账号ID({{ makeIndex(index) }})</div>
                                        <el-button v-if="index > 0 && permission.edit" type="primary" class="del-button del-id"  plain @click="removeId(index, 1)">
                                            删除ID
                                        </el-button>
                                    </template>
                                    <el-input v-model="item.accountId" placeholder="请输入" clearable maxlength="48"
                                        type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                </el-form-item>
                                <!-- {{item.categoryId}} -->
                                <el-form-item label="所属五域类目" prop="categoryId">
                                    <template #label>
                                        <div class="custom-label">所属<br />五域类目</div>
                                    </template>
                                    <el-cascader size="mini" clearable v-model="item.categoryId" :options="categoryIdList"
                                        :props="{
                                            label: 'categoryName',
                                            value: 'id',
                                            emitPath: false,
                                        }" filterable  :disabled="!permission.edit"></el-cascader>
                                </el-form-item>
                                <el-form-item label="渠道号">
                                    <el-input v-model="item.channelName" placeholder="请输入" clearable maxlength="32" show-word-limit :disabled="!permission.edit"></el-input>
                                </el-form-item>
                                <el-form-item label="ID使用状态" :prop="`mainAccount.accountIdList[${index}].status`" >
                                    <template #label>
                                        <div class="custom-label">ID使用状态</div>
                                    </template>
                                    <el-select v-model="item.status" placeholder="请选择" :disabled="!permission.edit">
                                        <el-option v-for="items in dictionaries.Property_platform_id_status"
                                            :key="items.dictId" :label="items.dictName" :value="items.dictId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </template>
                    </template>
                    <!-- 主账号 结束 -->
                    <!-- 子账号 开始 -->
                    <div v-if="form.hasSubsidiary == 1">
                        <div v-for="(subAccountItem, index) in form.subAccountList" :key="'sub-account-' + index">
                            <div class="line"></div>
                            <div class="text">子账号{{ makeIndex(index) }}<el-button
                                    v-if="index > 0 && permission.edit" class="del-button del-sub" @click="removeId(index, 4)"
                                    type="primary" plain>删除子账号</el-button></div>
                            <el-form-item label="登录账号" :prop="`subAccountList[${index}].account`">
                                <div class="textarea-con">
                                    <el-input v-model="form.subAccountList[index].account" placeholder="请输入" clearable maxlength="48" type="textarea" style="width: 204px;" rows="3" show-word-limit  :disabled="!permission.edit"></el-input>
                                    <template  v-if="permission.copy">
                                        <div v-if="form.subAccountList[index].account" class="btn-copy" @click="onCopy(form.subAccountList[index].account)">复</div>
                                        <div v-else class="btn-copy btn-copy-dis">复</div>
                                    </template>
                                </div>
                            </el-form-item>
                            <el-form-item label="账号密码">
                                <!-- <el-input v-model="form.subAccountList[index].password" placeholder="请输入" clearable maxlength="48" type="textarea" style="width: 204px;" rows="3" show-word-limit></el-input> -->
                                <div class="textarea-con">
                                    <!-- 编辑 -->
                                    <template  v-if="isDetail">
                                        <el-input v-if="form.subAccountList[index].passwordEye" v-model="form.subAccountList[index].password" placeholder="请输入" clearable maxlength="48" type="textarea"  rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                        <el-input v-else-if="form.subAccountList[index].id" value="******" clearable maxlength="48" type="textarea"  rows="3" readonly></el-input>
                                        <!-- 编辑无ID就是新增 -->
                                        <el-input v-else v-model="form.subAccountList[index].password" placeholder="请输入" clearable maxlength="48" type="textarea"  rows="3" show-word-limit></el-input>
                                    </template>
                                    <!-- 新建 -->
                                    <el-input v-else v-model="form.subAccountList[index].password" placeholder="请输入" clearable maxlength="48" type="textarea"  rows="3" show-word-limit></el-input>
                                    <!-- 复制查看按钮 -->
                                    <template  v-if="permission.copy">
                                        <div v-if="form.subAccountList[index].password" class="btn-copy" @click="onCopy(form.subAccountList[index].password)">复</div>
                                        <div v-else class="btn-copy btn-copy-dis">复</div>
                                    </template>
                                    <template  v-if="form.subAccountList[index].id &&  permission.password">
                                        <div v-if="form.subAccountList[index].passworddEye" class="i-eye" @click="onEye('sub',index)" ></div>
                                        <div v-else class="i-eye-hide" @click="onEye('sub',index)"></div>
                                    </template>
                                </div>
                            </el-form-item>
                            <el-form-item label="账号使用人" :prop="`subAccountList[${index}].usingUserIdList`">
                                <template #label>
                                    <div class="custom-label">账号使用人</div>
                                </template>
                                <el-select v-model="form.subAccountList[index].usingUserList" @click.native="openUserPicker(permission.edit,'sub', index)" :key="'sub-'+index" value-key="name"
                                            class="select-u" :class="!permission.edit ? 'disabled' : ''"  placeholder="选择账号使用人" collapse-tags
                                            size="medium" multiple popper-class="hidden" :disabled="!permission.edit">
                                    <el-option v-for="(wc, index) in form.subAccountList[index].usingUserList" :label="wc.name" :key="'sub-'+index" :value="wc"></el-option>
                                </el-select>

                            </el-form-item>
                            <div class="clear-both"></div>
                            <el-form-item label="账号绑定手机号" :prop="`subAccountList[${index}].phone`" class="label-star">
                                <template #label>
                                    <div class="custom-label">账号绑定<br />手机号</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].phone" placeholder="请输入" clearable maxlength="11"
                                    @input="getOwnerName('sub', 'phone',index)" show-word-limit :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定手机号所属员工">
                                <template #label>
                                    <div class="custom-label">绑定手机号<br />所属员工</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].phoneOwner" placeholder="自动识别" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="绑定微信号" :prop="`subAccountList[${index}].wechat`">
                                <template #label>
                                    <div class="custom-label">绑定微信号</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].wechat" placeholder="请输入" clearable maxlength="20"
                                    @input="getOwnerName('sub', 'wechat',index)" show-word-limit :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定微信号所属员工">
                                <template #label>
                                    <div class="custom-label">绑定微信号<br />所属员工</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].wechatOwner" placeholder="自动识别" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="绑定QQ号" :prop="`subAccountList[${index}].qq`">
                                <template #label>
                                    <div class="custom-label">绑定QQ号</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].qq" placeholder="请输入" clearable maxlength="12"
                                    @input="getOwnerName('sub', 'qq',index)" show-word-limit :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定QQ号所属员工">
                                <template #label>
                                    <div class="custom-label">绑定QQ号<br />所属员工</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].qqOwner" placeholder="自动识别" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="绑定邮箱" :prop="`subAccountList[${index}].email`">
                                <template #label>
                                    <div class="custom-label">绑定邮箱</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].email" placeholder="请输入" clearable maxlength="256"
                                    @input="getOwnerName('sub', 'email',index)" :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定邮箱所属员工">
                                <template #label>
                                    <div class="custom-label">绑定邮箱<br />所属员工</div>
                                </template>
                                <el-input v-model="form.subAccountList[index].emailOwner" placeholder="自动识别" disabled></el-input>
                            </el-form-item>
                            <div>
                                <el-form-item label="是否有ID"  :prop="`subAccountList[${index}].hasId`">
                                    <template #label>
                                        <div class="custom-label">是否有ID</div>
                                    </template>
                                    <el-radio-group v-model="form.subAccountList[index].hasId" class="radio-group" @change="toggleSubHasId($event, index)" :disabled="!permission.edit">
                                        <el-radio v-for="item in hasIdList" :key="item.dictId" :label="item.dictId">{{
                                            item.dictName }}</el-radio>
                                    </el-radio-group>
                                    <el-button type="primary" v-if="form.subAccountList[index].hasId == 1 && permission.edit"  plain @click="addPlus(2, index)"  class="add-button add-id">
                                        <i class="el-icon-plus"></i>
                                        新增ID
                                    </el-button>
                                </el-form-item>
                            </div>
                            <template v-if="subAccountItem.hasId === 1 &&  subAccountItem.accountIdList.length>0" >
                                <div v-for="(item, idIndex) in subAccountItem.accountIdList" :key="'sub-id-' + idIndex">
                                    <el-form-item label="账号ID（01）">
                                        <template #label>
                                            <div class="custom-label">账号ID（{{makeIndex(idIndex)}}）
                                            </div>
                                            <el-button v-if="idIndex > 0 && permission.edit" type="primary" class="del-button del-id" plain
                                                @click="removeId(idIndex, 2, index)">
                                                删除ID
                                            </el-button>
                                        </template>
                                        <el-input v-model="item.accountId" placeholder="请输入" clearable maxlength="40"
                                            type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                    </el-form-item>
                                    <el-form-item label="所属五域类目" prop="categoryId">
                                        <template #label>
                                            <div class="custom-label">所属<br />五域类目</div>
                                        </template>
                                        <el-cascader size="mini" clearable v-model="item.categoryId"
                                            :options="categoryIdList" :props="{
                                                label: 'categoryName',
                                                value: 'id',
                                                emitPath: false,
                                            }" filterable :disabled="!permission.edit"></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="渠道号">
                                        <el-input v-model="item.channelName" placeholder="请输入" clearable maxlength="32"
                                            type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                                    </el-form-item>
                                    <el-form-item label="ID使用状态" :prop="`subAccountList[${index}].accountIdList[${idIndex}].status`">
                                        <template #label>
                                            <div class="custom-label">ID使用状态</div>
                                        </template>
                                        <el-select v-model="item.status" placeholder="请选择" :disabled="!permission.edit">
                                            <el-option v-for="items in dictionaries.Property_platform_id_status"
                                                :key="items.dictId" :label="items.dictName"
                                                :value="items.dictId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </template>
                        </div>
                        <!-- <div class="add-sub" plain @click="addPlus(4)" >
                            <i class="el-icon-plus"></i>
                            新增子账号
                        </div> -->
                        <el-button type="primary" plain  @click="addPlus(4)"  class="add-button add-sub" v-if="permission.edit">
                            <i class="el-icon-plus"></i>
                            新增子账号
                        </el-button>
                    </div>
                    <div class="line"></div>
                    <div class="text">其他信息</div>
                    <div>
                        <el-form-item label="是否有店铺" prop="hasShop">
                            <template #label>
                                <div class="custom-label">是否有店铺</div>
                            </template>
                            <el-radio-group v-model="form.hasShop" class="radio-group" @change="toggleHasShop" :disabled="!permission.edit">
                                <el-radio v-for="item in hasShopList" :key="item.dictId" :label="item.dictId">{{item.dictName}}</el-radio>
                            </el-radio-group>
                            <el-button type="primary" plain @click="addPlus(3)" class="add-button add-shop" v-if="form.hasShop == 1 && permission.edit">
                                <i class="el-icon-plus"></i>
                                新增店铺
                            </el-button>
                        </el-form-item>
                    </div>
                    <template v-if="form.hasShop == 1">
                        <div v-for="(item, index) in form.shopList" :key="'shop-' + index">
                            <el-form-item label="店铺名称" :prop="`shopList[${index}].shopName`">
                                <template #label>
                                    <div class="custom-label">店铺{{ makeIndex(index) }}<br/>名称</div>
                                    <el-button v-if="index > 0 && permission.edit" type="primary" plain @click="removeId(index, 3)" class="del-button del-shop">
                                        删除店铺
                                    </el-button>
                                </template>
                                <el-input v-model="item.shopName" placeholder="请输入" clearable maxlength="48"
                                    type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="店铺ID"  :prop="`shopList[${index}].shopId`">
                                <template #label>
                                    <div class="custom-label">店铺{{ makeIndex(index) }}ID</div>
                                </template>
                                <el-input v-model="item.shopId" placeholder="请输入" clearable maxlength="48"
                                    type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                            </el-form-item>
                            <el-form-item label="店铺状态" :prop="`shopList[${index}].status`">
                                <template #label>
                                    <div class="custom-label">店铺{{ makeIndex(index) }}<br/>状态</div>
                                </template>
                                <el-select v-model="item.status" placeholder="请选择" :disabled="!permission.edit">
                                    <el-option v-for="items in dictionaries.property_platform_shop_status"
                                        :key="items.dictId" :label="items.dictName" :value="items.dictId"></el-option>
                                </el-select>
                            </el-form-item>
                            
                        </div>
                    </template>

                    <el-form-item label="平台账号备注">
                        <template #label>
                            <div class="custom-label">平台账号<br />备注</div>
                        </template>
                        <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                    </el-form-item>
                </el-form>
                <template v-if="isDetail">
                    <div class="line"></div>
                    <div class="text">更多信息</div>
                    <el-form :inline="true" class="form-list" size="small" label-width="96px">
                        <el-form-item label="创建时间："><div class="con">{{ form.createdTime || '-' }}</div></el-form-item>
                        <el-form-item label="创建人："><div class="con">{{ form.createdByName || '-' }}</div></el-form-item>
                        <el-form-item label="平台账号状态：">
                            <template #label>
                                <div class="custom-label">平台账号&nbsp;&nbsp;&nbsp;<br />状态：</div>
                            </template>
                            <div class="con">
                                <span v-if="form.statusLabel" :class="'icon-status icon-status-' + form.status"> {{ form.statusLabel}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="最后归属人："><div class="con">{{ form.ownerUserName || '-' }}</div></el-form-item>
                        <el-form-item label="更新时间："><div class="con">{{ form.updatedTime || '-' }}</div></el-form-item>
                        <el-form-item label="最近更新人："><div class="con">{{ form.updatedByName || '-' }}</div></el-form-item>
                        <el-form-item label="最后归属部门：">
                            <template #label>
                                <div class="custom-label">最后&nbsp;&nbsp;&nbsp;<br />归属部门：</div>
                            </template>
                            <div class="con">{{ form.ownerDeptName || '-' }}</div></el-form-item>
                        <el-form-item v-if="form.status==3 && form.cancelReason" label="注销原因："><div class="con">{{ form.cancelReason }}</div></el-form-item>    
                        <el-form-item label="历史记录："  v-if="permission.history"><div class="con"><el-button type="primary" class="btn-look" @click="$emit('onHistory')" plain size="mini">查看</el-button></div></el-form-item>
                    </el-form>
                </template>
            </div>
            <org-picker title="账号使用人" :multiple="true" ref="orgPicker" @ok="selectedUser" />
        </template>
        <div v-else-if="hasPermission===0" class="no-permission">
            <div class="pic"></div>
            <div class="word">抱歉，您缺少权限</div>
        </div>
    </div>
</template>
<script>
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';
import OrgPicker from "@/components/OrgPicker";
import FormDefault from "@/pages/assetManagement/common/consts/formDefault.js";

export default {
    name: 'platformAccountAdd',
    components: { OrgPicker },
    props: {
        isDetail: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hasPermission:NaN,
            currentPickerType: null,//'main' 或 'sub'
            dictionaries: {
                // property_act_status: [], // 审批状态
                // property_phone_status: [], // 状态
                // property_paccount_platform: [], // 所属平台
                property_paccount_reg_type: [], // 注册形式
                property_paccount_ustatus: [], // 使用状态
                // property_platform_account_lost: [], // 资料缺失情况
                // employee_status: [], // 员工状态
                Property_platform_id_status: [], // ID使用状态
                property_platform_shop_status: [], // 店铺状态
            },
            rules: {
                usingStatus: [
                    { required: true, message: '请选择使用状态', trigger: 'change' }
                ],
                platformKey: [
                    { required: true, message: '请选择使用状态', trigger: 'change' }
                ],
                loginUrl: [
                    { required: true, message: '请输入登录网址', trigger: 'blur' }
                ],
                hasSubsidiary: [
                    { required: true, message: '请选择是否有子账号', trigger: 'change' }
                ],
                regType: [
                    { required: true, message: '请选择注册形式', trigger: 'change' }
                ],
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法人或经营人', trigger: 'blur' }
                ],
                'mainAccount.account': [
                    { required: true, message: '请输入登录账号', trigger: 'blur' }
                ],
                'mainAccount.hasId': [
                    { required: true, message: '请选择是否有ID', trigger: 'blur' }
                ],
                'mainAccount.qq': [
                    { pattern: REGEX.QQ, message: '请输入正确的QQ号', trigger: 'change' }
                ],
                'mainAccount.phone': [
                     { required: true, message: '请输入绑定手机号', trigger: 'blur' },
                    { pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: 'change' }
                ],
                'mainAccount.wechat': [
                    { pattern: REGEX.WECHAT, message: '请输入正确的微信号', trigger: 'change' }
                ],
                'mainAccount.email': [
                    { pattern: REGEX.EMAIL, message: '请输入正确的邮箱', trigger: 'change' }
                ],
                'mainAccount.accountIdList[0].status': [
                    { required: true,   message: '请选择ID使用状态',trigger: 'change' },
                ],
                'subAccountList[0].account': [
                    { required: true, message: '请输入登录账号', trigger: 'blur' }
                ],

                'subAccountList[0].hasId': [
                    { required: true, message: '请选择是否有ID', trigger: 'blur' }
                ],
                'subAccountList[0].qq': [
                    { pattern: REGEX.QQ, message: '请输入正确的QQ号', trigger: 'change' }
                ],
                'subAccountList[0].phone': [
                    { required: true, message: '请输入绑定手机号', trigger: 'blur' },
                    { pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: 'change' }
                ],
                'subAccountList[0].wechat': [
                    { pattern: REGEX.WECHAT, message: '请输入正确的微信号', trigger: 'change' }
                ],
                'subAccountList[0].email': [
                    { pattern: REGEX.EMAIL, message: '请输入正确的邮箱', trigger: 'change' }
                ],
                'subAccountList[0].accountIdList[0].status': [
                    { required: true,   message: '请选择ID使用状态',trigger: 'change' },
                ],
                hasShop: [
                    { required: true,  trigger: 'change' },
                ],
                'shopList[0].shopName': [
                    { required: true, message: '请输入店铺名称', trigger: 'blur' }
                ],
                'shopList[0].shopId': [
                    { required: true, message: '请输入店铺ID', trigger: 'blur' }
                ],
                'shopList[0].status': [
                    { required: true, message: '请选择店铺状态', trigger: 'blur' }
                ]
            },
            shops: {},
            categoryIdList: [],
            idIndex: 0,
            subIndex: 0,
            id:'',
            form:JSON.parse(JSON.stringify(FormDefault)) ,
            permission:{},
            currentSubIndex: null,
            hasSubsidiaryList: [
                { dictId: 1, dictName: '是' },
                { dictId: 0, dictName: '否' },
            ],
            hasIdList: [
                { dictId: 1, dictName: '是' },
                { dictId: 0, dictName: '否' },
            ],
            hasShopList: [
                { dictId: 1, dictName: '是' },
                { dictId: 0, dictName: '否' },
            ],
        }
    },
    activated() {
        this.$refs.form && this.$refs.form.clearValidate()
    },
    mounted() {
        this.init()
    },
    methods: {
        init() { 
            this.getShop()
            this.getCategory()
            for (const type in this.dictionaries) {
                this.getDictionaries(type)
            }
        },
        save() {
            console.log('>>', this.form)
            // return false
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$parent.btnSave = true
                    // 优化空值处理逻辑
                    this.form.mainAccount.phone = this.form.mainAccount.phone || null
                    this.form.mainAccount.qq = this.form.mainAccount.qq || null
                    this.form.mainAccount.wechat = this.form.mainAccount.wechat || null
                    this.form.mainAccount.email = this.form.mainAccount.email || null
                    if(this.form.hasSubsidiary==1 && this.form.subAccountList.length>0){
                        this.form.subAccountList.forEach(item=>{
                            item.phone = item.phone || null
                            item.qq = item.qq || null
                            item.wechat = item.wechat || null
                            item.email = item.email || null
                        })
                    }
                    // 是否有子账号
                    if(this.form.hasSubsidiary == 0){
                        this.form.subAccountList = null
                    }
                    // 主账号是否有ID
                    if(this.form.mainAccount.hasId == 0){
                        this.form.mainAccount.accountIdList = null
                    }
                    // 子账号是否有ID
                    if(this.form.hasSubsidiary==1 && this.form.subAccountList.length>0){
                         this.form.subAccountList.forEach(item=>{
                            if(item.hasId==0){
                                item.accountIdList = null
                            }
                        })
                    }
                    // 是否有店铺
                    if(this.form.hasShop === 0){
                        this.form.shopList = null
                    }
                    
                    if(this.form.regType ==2){
                        this.form.companyName = ''
                        this.form.legalPerson = ''
                    }
                    // 主账号是否修改密码
                    if(this.form.mainAccount.passwordLooked){
                        this.form.mainAccount.passwordChanged = (this.form.mainAccount.password != this.form.mainAccount.passwordReal)
                    }else{
                        this.form.mainAccount.passwordChanged = false
                    }
                    // 子账号是否修改密码
                    if(this.form.hasSubsidiary==1 && this.form.subAccountList.length>0){
                        this.form.subAccountList.forEach(item=>{
                            if(item.passwordLooked){
                                item.passwordChanged = (item.password != item.passwordReal)
                            }else{
                                item.passwordChanged = false
                            }
                        })
                    }
                    this.axios.post('/oa/sys/property/platformAccount/edit', this.form).then((res) => {
                        if (res.code == 0) {
                            if(this.isDetail){
                              this.$message({ message: '修改成功', type: 'success' })
                              this.fetchData()
                            }else{
                               this.$message({ message: '新增成功', type: 'success' })
                               this.$parent.back()
                            }
                            
                        } else {
                            this.$message.error(res.message)
                        }
                    }).finally(() => {
                        this.$parent.btnSave = false
                    })
                }
            })
        },
        addPlus(val, subIndex = 0) {
            if (val === 1) {
                // 新增主账号ID
                const idIndex = this.form.mainAccount.accountIdList.length;
                this.setMainIdRules(idIndex, [
                    { field: 'status', message: '请选择店铺状态' }
                ]);
                this.form.mainAccount.accountIdList.push({
                    accountId: "",      // 账号ID
                    categoryId: null,   // 所属五域类目
                    channelName: "",    // 渠道号
                    status: ""          // ID使用状态
                });
                console.log(this.rules);
            } else if (val == 2) {
                // 新增子账号ID
                console.log(subIndex,this.form.subAccountList)
                const idIndex = this.form.subAccountList[subIndex].accountIdList.length;
                this.setSubIdRules(subIndex,idIndex, [
                    { field: 'status', message: '请选择店铺状态' }
                ]);
                if (this.form.hasSubsidiary === 1 && this.form.subAccountList[subIndex]) {
                    if (!this.form.subAccountList[subIndex].accountIdList) {
                        this.$set(this.form.subAccountList[subIndex], 'accountIdList', [])
                    }
                    this.form.subAccountList[subIndex].accountIdList.push({
                        accountId: "",      // 账号ID
                        categoryId: null,   // 所属五域类目
                        channelName: "",    // 渠道号
                        status: ""          // ID使用状态
                    })
                };
            } else if (val == 3) {
                // 新增店铺时动态添加规则
                const shopIndex = this.form.shopList.length;
                this.setShopRules(shopIndex, [
                    { field: 'shopName', message: '请输入店铺名称' },
                    { field: 'shopId', message: '请输入店铺ID' },
                    { field: 'status', message: '请选择店铺状态' }
                ]);
                this.form.shopList.push({
                    shopName: "",      // 店铺名称
                    shopId: null,      // 店铺ID
                    status: ""          // 店铺状态
                })
            } else if (val == 4) {
                // 新增子账号
                const subAccountIndex = this.form.subAccountList.length;
                this.setSubRules(subAccountIndex, [
                    { field: 'account',required:true, message: '请输入子账号登录账号' , trigger: 'blur' },
                    { field: 'phone',required:true, message: '请输入绑定手机号' , trigger: 'blur' },
                    { field: 'hasId', required:true, message: '请选择是否有ID', trigger: ['blur','change']  },
                    { field: 'qq',required:false, pattern: REGEX.QQ, message: '请输入正确的QQ号', trigger: 'change'},
                    { field: 'phone',required:false, pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: 'change' },
                    { field: 'wechat',required:false, pattern: REGEX.WECHAT, message: '请输入正确的微信号', trigger: 'change' },
                    { field: 'email',required:false, pattern: REGEX.EMAIL, message: '请输入正确的邮箱', trigger: 'change' },
                    
                ]);
                this.setSubIdRules(subAccountIndex,0, [
                    { field: 'status', message: '请选择店铺状态' }
                ]);
                console.log(this.form,this.rules);
                // 新增子账号
                this.form.subAccountList.push({
                    account: '',
                    password: '',
                    wechat: '',
                    wechatOwner: '',  // 新增字段
                    phone: '',
                    phoneOwner: '',   // 新增字段
                    qq: '',
                    qqOwner: '',      // 新增字段
                    email: '',
                    emailOwner: '',   // 新增字段
                    hasId: 1,
                    accountIdList: [
                        {
                            accountId: "",      // 账号ID
                            categoryId: null,   // 所属五域类目
                            channelName: "",    // 渠道号
                            status: ""          // ID使用状态
                        }
                    ],
                    usingUserList: [],
                    usingUserIdList: []
                })
            }
        },
        setMainIdRules(shopIndex, fields) {
            fields.forEach(field => {
                this.$set(this.rules, 
                    `mainAccount.accountIdList[${shopIndex}].${field.field}`,
                    [{ required: true, message: field.message, trigger: 'change' }]
                );
            });
        },
        setSubIdRules(subIndex,shopIndex, fields) {
            fields.forEach(field => {
                this.$set(this.rules, 
                    `subAccountList[${subIndex}].accountIdList[${shopIndex}].${field.field}`,
                    [{ required: true, message: field.message, trigger: 'change' }]
                );
            });
        },
        // 新增方法：统一设置店铺校验规则
        setShopRules(shopIndex, fields) {
            fields.forEach(field => {
                this.$set(this.rules, 
                    `shopList[${shopIndex}].${field.field}`,
                    [{ required: true, message: field.message, trigger: 'blur' }]
                );
            });
        },
        setSubRules(shopIndex, fields) {
            fields.forEach(field => {
                this.$set(this.rules, 
                    `subAccountList[${shopIndex}].${field.field}`,
                    [{ 
                        required: field.required,
                        pattern: field.pattern || '',
                        message: field.message, 
                        trigger: field.trigger,
                        type: field.field === 'hasId' ? 'number' : undefined
                    }]
                );
            });
        },

        // 删除ID方法
        removeId(idIndex, type, subIndex = 0) {
            if (type === 1) {
                const removedId = this.form.mainAccount.accountIdList[idIndex].id;
                this.form.mainAccount.accountIdList.splice(idIndex, 1);

                // 如果删除的不是最大的ID，则不需要调整计数器
                // 如果删除的是当前最大的ID，则更新计数器
                if (removedId === this.nextIdIndex - 1) {
                    this.nextIdIndex--;
                }
                // this.form.mainAccount.accountIdList.splice(idIndex, 1);
            } else if (type === 2) {
                if (this.form.subAccountList[subIndex]) {
                    if (!this.form.subAccountList[subIndex].accountIdList) {
                        this.$set(this.form.subAccountList[subIndex], 'accountIdList', []);
                    }
                    // 执行删除
                    this.form.subAccountList[subIndex].accountIdList.splice(idIndex, 1);
                }
            } else if (type === 3) {
                // 删除店铺时同时删除对应的规则
                const removedShopIndex = idIndex;
                // this.$delete(this.rules, `shopList[${removedShopIndex}].shopName`);
                
                this.form.shopList.splice(removedShopIndex, 1);
                
                // // 重新索引剩余的规则
                // this.form.shopList.forEach((shop, index) => {
                //     if (this.rules[`shopList[${index}].shopName`]) {
                //         this.$set(this.rules, `shopList[${index}].shopName`, this.rules[`shopList[${removedShopIndex}].shopName`]);
                //         this.$delete(this.rules, `shopList[${removedShopIndex}].shopName`);
                //     }
                // });
            } else if (type === 4) {
                const index = this.subIndex;
                const removedId = this.form.subAccountList[idIndex].id;
                console.log(idIndex, '子账号索引');

                this.form.subAccountList.splice(idIndex, 1);
                if (removedId === this.nextIdIndex - 1) {
                    this.nextIdIndex--;
                }
            }
        },
        //用户选择回调
        selectedUser(data) {
            // if (!data || data.length === 0) return;
            if (this.currentPickerType === 'main') {
                console.log(data, '原数据');
                this.form.mainAccount.usingUserList = data;
                this.form.mainAccount.usingUserIdList = data.map(e=>e.id)
            } else if (this.currentPickerType === 'sub') {
                // 使用存储的索引
                if (this.currentSubIndex !== null) {
                    this.form.subAccountList[this.currentSubIndex].usingUserList = data;
                    this.form.subAccountList[this.currentSubIndex].usingUserIdList = data.map(e=>e.id)
                }
            }

            this.currentPickerType = null;
            this.currentSubIndex = null;
        },
        // 账号使用人选择
        openUserPicker(permission,type, index) {
            if (!permission) return;
            console.log('permission:',permission)
            this.currentPickerType = type;
            console.log('openUserPicker', type);
            let selectedUsers
            if(type ==='main'){
                selectedUsers = this.form.mainAccount.usingUserList
            }else if (type === 'sub') {
                this.currentSubIndex = index; // 新增这行
                selectedUsers =  this.form.subAccountList[this.currentSubIndex].usingUserList
            }
            console.log('selectedUsers', selectedUsers);
            this.$refs.orgPicker.show(selectedUsers, 'user');
        },

        //获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) {
                return
            }
            const params = { groupId: type }
            this.$api.dictionaries(params).then(res => {
                this.dictionaries[type] = res.data || []
            }).catch((err) => {
                console.log(err)
            })
        },
        //所属平台
        getShop() {
            this.$api.getShopPlatform().then((res) => { 
                if (res.code == 0) {
                    this.shops = res.data|| []
                }
            })
        },
        //五域类目
        getCategory() {
             this.$api.getCategoryExtracted({
                params: {
                    pageSize: 10000
                }
            }).then((res) => {
                if (res.code == 0) {
                    this.categoryIdList = res.data || []
                }
            })
        },
        getOwnerName(accountType, fieldType,subIndex = 0) {
            let accountValue = '';
            let targetField = '';
            let url = '';
            let text = ''
            // 确定目标对象（主账号或子账号）
            const targetObj = accountType === 'main'
                ? this.form.mainAccount
                : this.form.subAccountList[subIndex];

            // 设置接口URL和目标字段
            switch (fieldType) {
                case 'wechat':
                    accountValue = targetObj.wechat;
                    targetField = 'wechatOwner';
                    url = 'workWechatFindName';
                    text = '该微信号无登记'
                    if(!REGEX.WECHAT.test(accountValue)){
                        targetObj[targetField] = '';
                        return false;
                    }
                    break;
                case 'phone':
                    accountValue = targetObj.phone;
                    targetField = 'phoneOwner';
                    url = 'workPhoneFindName';
                    text = '该手机号无登记'
                    
                    if(!REGEX.PHONE.test(accountValue)){
                        targetObj[targetField] = '';
                        return false;
                    }
                    break;
                case 'qq':
                    accountValue = targetObj.qq;
                    targetField = 'qqOwner';
                    url = 'workQQFindName';
                    text = '该QQ号无登记'
                    if(!REGEX.QQ.test(accountValue)){
                        targetObj[targetField] = '';
                        return false;
                    }
                    break;
                case 'email':
                    accountValue = targetObj.email;
                    targetField = 'emailOwner';
                    url = 'workEmailFindName';
                    text = '该邮箱无登记'
                    if(!REGEX.EMAIL.test(accountValue)){
                        targetObj[targetField] = '';
                        return false;
                    }
                    break;
            }

            if (!accountValue) {
                // this.$message.warning(`请输入${this.getFieldName(fieldType)}`);
                targetObj[targetField] = '';
                return;
            }
            this.$api[url]({ account: accountValue }).then(res => {
                if (res.code === 0) {
                    // console.log(res.data);
                    targetObj[targetField] = res.data || text
                } else {
                    targetObj[targetField] = text;
                }
            }).catch(err => {
                this.$message.error('查询失败');
                console.error(err);
                targetObj[targetField] = '';
            });
        },
        // 获取字段中文名称
        getFieldName(fieldType) {
            const names = {
                wechat: '微信号',
                phone: '手机号',
                qq: 'QQ号',
                email: '邮箱'
            };
            return names[fieldType] || '账号';
        },
        reset(){
            if(this.isDetail){
                this.hasPermission = NaN
                // 重置数据
                this.id = this.$route.query.id
                if(this.id){
                    this.fetchData()
                }
                
            }else{
                this.hasPermission = 1
                this.permission = {
                    edit:1
                }
                // this.form = {...FormDefault};
                this.form = JSON.parse(JSON.stringify(FormDefault)) 
                this.$refs.form && this.$refs.form.resetFields()
            }
           
        },
        fetchData() {
            this.fetchDataDetail()
            this.getDataPermission()
        },
        fetchDataDetail() {
            this.form = JSON.parse(JSON.stringify(FormDefault))
            this.axios.get('/oa/sys/property/platformAccount/detail', {
                params: {
                    id: this.id
                }
            }).then((res) => {
                if (res.code == 0) {
                    let form = res.data
                    let usingUserList = [] 
                    
                    // 主账号使用人回显
                    if(form.mainAccount && form.mainAccount.usingUserIdList && form.mainAccount.usingUserIdList.length > 0){     
                       form.mainAccount.usingUserIdList.forEach((id,index) => {
                           usingUserList.push({
                            id: id,
                            name: form.mainAccount.usingUserNameList[index],
                            type:'user'
                           })
                       })
                    }
                    if(form.mainAccount){
                        form.mainAccount.usingUserList = usingUserList
                    }
                    // 子账号使用人回显
                    if(form.subAccountList && form.subAccountList.length > 0 && form.subAccountList[0].usingUserIdList && form.subAccountList[0].usingUserIdList.length > 0){     
                        form.subAccountList.forEach((subAccountItem) => {
                            let usingUserListSub = []  
                            subAccountItem.usingUserIdList.forEach((id,index) => {
                                usingUserListSub.push({
                                    id: id,
                                    name: subAccountItem.usingUserNameList[index],
                                    type:'user'
                                })
                            })
                            subAccountItem.usingUserList = usingUserListSub
                        })
                    }
                    let listName = ['phone','wechat','qq','email']
                    // 主账号归属回显
                    if ( form.mainAccount) {
                        listName.forEach(name=>{
                        let owner = name+'Owner'
                        form.mainAccount[owner] = ''
                        if(form.mainAccount[name]){
                                this.$nextTick(()=>{
                                    this.getOwnerName('main', name)
                                })
                            }
                        })
                    console.log(form.mainAccount)
                    }
                    
                    if(form.subAccountList && form.subAccountList.length>0){
                        form.subAccountList.forEach((subAccountItem,index) =>{
                            subAccountItem.passwordEye = false
                            subAccountItem.passwordChanged = false
                            subAccountItem.passwordLooked = false
                            subAccountItem.phoneOwner = ''
                            subAccountItem.wechatOwner = ''
                            subAccountItem.qqOwner = ''
                            subAccountItem.emailOwner = ''
                            listName.forEach(name=>{
                                if(subAccountItem[name]){
                                    let owner = name+'Owner'
                                    subAccountItem[owner] = ''
                                    this.$nextTick(()=>{
                                        this.getOwnerName('sub', name,index)
                                    })
                                }
                            })
                        })
                    }
                    // 判断密码是否被修改
                    if( form.mainAccount){
                        form.mainAccount.passwordChanged = false
                        form.mainAccount.passwordEye = false
                    }

                    this.form = form
                    
                    console.log('detail:',this.form)
                    this.hasPermission = 1
                }else if(res.code == 501){
                    this.hasPermission = 0
                }
            })
        },
        getDataPermission() { 
            this.$parent.btnShow = false
            this.$api.platformCheckPermission({propertyIds:[this.id]}).then(res => {
                if (res.code == 0) {
                    const permission = ( res.data && res.data.accountPermissionMap && res.data.accountPermissionMap[this.id] ) || {}
                    this.permission = permission || {}
                    this.$parent.permission = permission
                    this.$parent.btnShow = true
                }
            })
        },
        // 复制
        onCopy(text){
            navigator.clipboard.writeText(text).then(() => {
                this.$message({ message: '复制成功', type: 'success' });
            }).catch(err => {
                this.$message.error('复制失败: ' + err);
            });
        },
        // 切换眼睛
        onEye(type,index){
            // console.log(type,password)
            if (type =='main') {
                const params = { accountListId: this.form.mainAccount.id }
                if(!this.form.mainAccount.passwordEye){
                    // console.log(this.form,params)
                    this.$api.platformAccountPassword(params).then(res => { 
                        this.form.mainAccount.passwordEye = true
                        this.form.mainAccount.passwordLooked = true 
                        this.form.mainAccount.password = res.data || ''
                        this.form.mainAccount.passwordReal = res.data || ''
                    })
                    // console.log('>>',this.form.mainAccount)
                }else{
                    this.form.mainAccount.passwordEye = false
                }
            }
            
            if(type =='sub' ){
               if(!this.form.subAccountList[index].passwordEye){
                    const params = { accountListId: this.form.subAccountList[index].id }
                    this.$api.platformAccountPassword(params).then(res => { 
                        this.form.subAccountList[index].passwordEye = true
                        this.form.subAccountList[index].passwordLooked = true 
                        this.form.subAccountList[index].password = res.data || ''
                        this.form.subAccountList[index].passwordReal = res.data || ''
                    })
                    console.log('>>',this.form.subAccountList[index])
                }else{
                    this.form.subAccountList[index].passwordEye = false
                }

            }
            // if(!this.myPassword){
            //     const params = { subId: this.form.subId }
            //     this.$api.workEmailPassword(params).then(res => { 
            //         this.eye = !this.eye
            //         this.myPassword = res.data
            //         this.form.password = this.myPassword
            //     })
            // }else{
            //     this.eye = !this.eye
            // }
        },
        makeIndex(index){
            return (index + 1).toString().padStart(2, '0')
        },
        // 切换是否有子账号
        toggleHasSubAccount(e){
             if(e == 1 && !this.form.subAccountList){
               this.form.subAccountList = [
                    {
                        account: '',
                        password: '',
                        wechat: null,
                        wechatOwner: '',  // 新增字段
                        phone: null,
                        phoneOwner: '',   // 新增字段
                        qq: null,
                        qqOwner: '',      // 新增字段
                        email: null,
                        emailOwner: '',   // 新增字段
                        hasId: 1,
                        passwordEye: false,
                        passwordChanged: false,
                        passwordLooked : false,
                        accountIdList: [
                            {
                            accountId: "",      // 账号ID
                            categoryId: null,   // 所属五域类目
                            channelName: "",    // 渠道号
                            status: ""          // ID使用状态
                            }
                        ],
                        usingUserList:[],
                        usingUserIdList: []
                    }] 
            }
        },
        // 切换主账号是否有ID
        toggleMainHasId(e){
            if(e == 1 && !this.form.mainAccount.accountIdList ){
               this.form.mainAccount.accountIdList = [
                {
                    accountId: "",      // 账号ID
                    categoryId: null,   // 所属五域类目
                    channelName: "",    // 渠道号
                    status: ""          // ID使用状态
                }] 
            }
        },
        // 切换子账号是否有ID 
        toggleSubHasId(e,index){
            console.log(e,index)
            if(e == 1 && !this.form.subAccountList[index].accountIdList ){
               this.form.subAccountList[index].accountIdList = [
                {
                    accountId: "",      // 账号ID
                    categoryId: null,   // 所属五域类目
                    channelName: "",    // 渠道号
                    status: ""          // ID使用状态
                }] 
            }
        },
        // 切换是否有店铺
        toggleHasShop(e) {
            if(e == 1 && !this.form.shopList ){
               this.form.shopList = [
                {
                    shopName: '',
                    shopId: '',
                    status: ''
                }] 
            }
        },
    },
}
</script>
<style lang="scss" scoped >
.forms {
    flex: 1;
    padding-bottom: 84px;
    // /deep/{
    //     .el-form{
    //         display: flex;
    //         flex-wrap: wrap;
    //     }
    //     .el-form-item{
    //         // flex: 1;
    //         display: flex;
    //         flex-wrap: wrap;
    //     }
    //     .el-form-item__label{
    //         white-space: nowrap;
    //         flex-shrink: 0;
    //     }
    // }
     /deep/ .el-textarea {
        .el-textarea__inner {
            padding-left: 8px;
            width: 204px;
            height: 64px;
        }

        .el-input__count {
            line-height: 1;
            bottom: 6px;
        }
    }
    /deep/{
        .el-select__tags{
            flex-wrap:nowrap ;
        }
        .el-tag__close{
            display: none;
        }
    }
    .text {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-top: 32px;
        margin-bottom: 30px;
    }
    p {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
    }
    .input-con{
        display: flex;
        .input{
            flex: 1;
            width: 164px;
            line-height: 1;
            /deep/.el-input__inner{
                border-right: none;
                border-radius:4px 0 0 4px;
            }
        }
        .btn-copy{
            width: 40px;
            height: 32px;
            border-radius: 0 4px 4px 0;
            background-color: #00B498;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #FFF;
            cursor: pointer; 
        }
        .btn-copy-dis{
            background-color: #E3E6E5;
            cursor: default;
        }
    }
    .textarea-con{
        position: relative;
        .btn-copy{
            position: absolute;
            right: 0;
            top: 0;
            zindex: 2;
            width: 18px;
            height: 18px;
            border-radius: 0 4px 0 4px;
            background-color: #00B498;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 11px;
            font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
            line-height: 1;
            color: #FFF;
            cursor: pointer;
            box-size: border-box;
        }
        .btn-copy-dis{
            background-color: #E3E6E5;
            cursor: default;
        }
         .i-eye,
        .i-eye-hide{
            position: absolute;
            right: 0;
            top: 22px;
            zindex: 2;
            display: inline-block;
            width: 18px;
            height: 20px;
            background-image: url("~@/assets/img/icon/icon_kejian.png");
            background-repeat: no-repeat;
            background-position: center center;
            cursor: pointer;
        }
        .i-eye-hide{
            background-image: url("~@/assets/img/icon/icon_kejian_hide.png");
        }
    }
    .clear-both{
        width: 100%;
        clear: both;
    }
    .radio-group{
        width: 127px;
    }
    
    .add-button{
        background-color: #FFF;
        padding: 8px;
        font-size: 14px;
        font-weight: normal;
        &:hover,
        &:focus,
        &:active{
            background-color: #e6f8f5;
            color: #00B498;
        }
    }
    .add-shop{
        width: 92px;
    }
    .add-id{
        width: 77px;
    }
    .add-sub{
        width: 100%;
        padding: 13px;
        border-radius: 0;  
    }
    .del-button{
        padding: 9px;
        border:none;
        &:hover,
        &:focus,
        &:active{
            background-color: #e6f8f5;
            color: #00B498;
        }
    }
    .del-sub{
        padding: 12px;
        margin-left: 10px;
    }
    .del-id{
        width: 60px;
        position: relative;
        top: -1px;
    }
    .del-shop{
        width: 68px;
        position: relative;
        top: -9px;
    }
}

.line {

    height: 1px;
    background: #EDF2F2;
    margin: 24px 0;
    box-sizing: border-box;
}

.form-list{
    /deep/ .el-form-item__label{
        color: #939696;
        font-family: PingFang SC, PingFang SC;
    }
    .con{
        min-width: 204px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #2F3030;
        word-break: break-word;
    }
    .btn-look{
        width: 44px;
        height: 28px;
        padding: 0;
        box-sizing: border-box;
    }
    // 手机状态 1待转移 2已转移 3已注销
    .icon-status {
        font-size: 14px;
        line-height: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        width: 50px;
        height: 24px;
        margin-left: 10px;
    }
    .icon-status-1 {
        color: #939696;
        background-color: #F7F7F7;
    }
    .icon-status-2 {
        color: #00B498;
        background-color: #E4F7F4;
    }
    .icon-status-3 {
        color: #E23C58;
        background-color: #FCE9EC;
    }
}
// 无权限
.no-permission{
    min-height: calc(100vh - 280px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .pic{
        width: 320px;
        height: 320px;
        background-image: url('~@/assets/img/img_wuquanxian.png');
    }
    .word{
        font-size: 14px;
        color: #2F3030;
    }
}
</style>
